import React from "react";
import "./SellSelectSection.css";

export const SellSelectSection = (props) => {
  const handleClick = () => {
    props.sendData(2);
  };
  return (
    <>
      <h1 className="heading_text mt-5">
        لمساعدتك بأفضل طريقة في زيادة مبيعاتك الرجاء الاختيار ماذا تبيع ؟{" "}
      </h1>
      <p className="sell_text mt-5">الاختيارات :</p>
      <div className="options_container mt-5">
        <span className="infusion-option">
          <input
            id="product"
            name="sell_labels"
            type="radio"
            value="product"
            className="d-none input_checked"
            checked={props.SellSelect === "product" ? true : false}
            onChange={(e) => props.setSellSelect(e.target.value)}
          />
          <label htmlFor="product" className="sell_labels">
            <i className="fa-solid fa-box-open icon_product"></i> منتج
          </label>
        </span>
        <span className="infusion-option">
          <input
            id="service"
            name="sell_labels"
            type="radio"
            value="service"
            checked={props.SellSelect === "service" ? true : false}
            className="d-none input_checked"
            onChange={(e) => props.setSellSelect(e.target.value)}
          />
          <label htmlFor="service" className="sell_labels">
            <i className="fa-solid fa-screwdriver-wrench icon_product"></i> خدمة
          </label>
        </span>
      </div>
      <button
        type="button"
        className="input_button button_width"
        disabled={props.SellSelect === "" ? true : false}
        onClick={() => handleClick()}
      >
        المتابعة <i className="fa fa-long-arrow-right ms-2" aria-hidden="true"></i>
      </button>
    </>
  );
};
